import { Component, OnInit } from '@angular/core';

// ionic
import { PopoverController } from '@ionic/angular';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-password-modal',
    templateUrl: './password-modal.component.html',
    styleUrls: ['./password-modal.component.scss'],
})
export class PasswordModalComponent implements OnInit {

    public passwordValue: string = "";

    constructor(
        private popoverController: PopoverController,
        public translate: TranslateService
    ) { }

    ngOnInit() {}

    close() {
        this.popoverController.dismiss();
    }

    /**
     * process form, validate note
     */
    join(valid) {
        if (valid) {
            this.popoverController.dismiss({
                password: this.passwordValue
            });
        }
    }

}
